import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class SettingsService {

  ajustes: Ajustes = {
    temaUrl: 'assets/css/colors/blue.css',
    tema: 'blue'
  };

  constructor( @Inject(DOCUMENT) private _document ) {
    this.cargarAjustes();
  }

  guardarAjustes() {
    localStorage.setItem('ajustes', JSON.stringify( this.ajustes )  );
  }

  cargarAjustes() {

    if (localStorage.getItem('quiensoy')) {
      if (localStorage.getItem('quiensoy') === 'base') {
        this.ajustes.tema = 'orangebase';
        this.ajustes.temaUrl = 'assets/css/colors/orangebase.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'factorblack') {
        this.ajustes.tema = 'blue-dark';
        this.ajustes.temaUrl = 'assets/css/colors/blue-dark.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'ventus') {
        this.ajustes.tema = 'ventus';
        this.ajustes.temaUrl = 'assets/css/colors/ventus.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'fliebentres') {
        this.ajustes.tema = 'fliebentres';
        this.ajustes.temaUrl = 'assets/css/colors/fliebentres.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'fliebencap') {
        this.ajustes.tema = 'fliebencap';
        this.ajustes.temaUrl = 'assets/css/colors/fliebencap.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'unita') {
        this.ajustes.tema = 'unita';
        this.ajustes.temaUrl = 'assets/css/colors/unita.css';
        this.aplicarTema( this.ajustes.tema );
      } else if (localStorage.getItem('quiensoy') === 'facturacion') {
        this.ajustes.tema = 'facturacion';
        this.ajustes.temaUrl = 'assets/css/colors/facturacion.css';
        this.aplicarTema( this.ajustes.tema );
      }
    } else {
    if ( localStorage.getItem('ajustes') ) {
      this.ajustes = JSON.parse( localStorage.getItem('ajustes') );

      this.aplicarTema( this.ajustes.tema );

    }else {

      this.aplicarTema( this.ajustes.tema );
    }
    }

    

  }

  aplicarTema( tema: string ) {


    let url = `assets/css/colors/${ tema }.css`;
    this._document.getElementById('tema').setAttribute('href', url );

    this.ajustes.tema = tema;
    this.ajustes.temaUrl = url;

   // this.guardarAjustes();

  }

}

interface Ajustes {
  temaUrl: string;
  tema: string;
}

